<div class="container-fluid mt-4">
    <div class="row">
        <!-- Partie gauche : Tableau des éléments à valider -->
        <div class="col-md-8">

            <mat-tab-group mat-align-tabs="start" #tabGroup (selectedIndexChange)="selectedChangeValue($event)"
                [(selectedIndex)]="indiceTab">
                <mat-tab label="Validation">
                    <div *ngIf="indiceTab == 0" style="overflow-x: hidden">
                        <div class="row">

                            <h5>Éléments à valider</h5>
                            <table class="table table-bordered">
                                <thead class="table-light">
                                    <tr>
                                        <th>ID</th>
                                        <th>Nom</th>
                                        <th>Statut</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of items">
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.status }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Historique validation">
                    <div *ngIf="indiceTab == 1" style="overflow-x: hidden">
                        <div class="row">
                            <h5>Éléments à valider</h5>
                            <table class="table table-bordered">
                                <thead class="table-light">
                                    <tr>
                                        <th>ID</th>
                                        <th>Nom</th>
                                        <th>Statut</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of items">
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.status }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </mat-tab>

            </mat-tab-group>

        </div>

        <div class="col-md-4">
            <div class="card p-3 shadow-sm">
                <h5 class="text-center">Formulaire de décision</h5>
                <form [formGroup]="decisionForm" (ngSubmit)="onSubmit()">

                    <!-- Sélection de la décision -->
                    <div class="mb-3">
                        <label for="decision" class="form-label">Choisir une action *</label>
                        <select id="decision" class="form-select" formControlName="decision">
                            <option value="" disabled selected>-- Sélectionner une action --</option>
                            <option value="validate">✅ Valider</option>
                            <option value="reject">❌ Rejeter</option>
                        </select>
                        <div *ngIf="isInvalid('decision')" class="text-danger mt-1">
                            Vous devez choisir une action.
                        </div>
                    </div>

                    <!-- Champ texte pour la raison -->
                    <div class="mb-3">
                        <label for="reason" class="form-label">Raison (Optionnel)</label>
                        <textarea id="reason" class="form-control" rows="3" formControlName="reason"></textarea>
                    </div>

                    <!-- Bouton de soumission -->
                    <button type="submit" class="btn btn-primary w-100">Soumettre</button>
                </form>
            </div>
        </div>
    </div>
</div>